
import { Profession } from '@/lib/professionTypes';
import { BriefcaseMedical, UsersRound, UserSquare, Briefcase, LucideIcon } from 'lucide-react';

// Segédfüggvény a szakmák csoportosításához főcsoport szerint
export const groupProfessionsByCategory = (professions: Profession[]) => {
  return professions.reduce<Record<string, Profession[]>>((groups, profession) => {
    const category = profession.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(profession);
    return groups;
  }, {});
};

// Ikon kiválasztása a kategória alapján
export const getCategoryIcon = (category: string): LucideIcon => {
  switch (category.toLowerCase()) {
    case 'orvos':
      return BriefcaseMedical;
    case 'szakdolgozó':
      return UsersRound;
    case 'szakfogorvos':
      return UserSquare;
    default:
      return Briefcase;
  }
};
